import { TableConfig } from '../../../../components/table/Table';

export const initBerechnteilposTableConfig = (): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Leistungsart',
      attributName: 'leistungsArt',
      valueType: 'string',
    },
    {
      id: 2,
      columnName: 'Tarif',
      attributName: 'tarif',
      valueType: 'string',
    },
    {
      id: 3,
      columnName: 'Version',
      attributName: 'version',
      valueType: 'string',
    },
    {
      id: 4,
      columnName: 'Ortsklasse',
      attributName: 'ortsKlasse',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'pflichtig',
      attributName: 'pflichtigerBetrag',
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 6,
      columnName: 'Bezug',
      attributName: 'bezug',
      valueType: 'string',
    },
    {
      id: 7,
      columnName: 'zu',
      attributName: 'zu',
      valueType: 'string',
    },
    {
      id: 8,
      columnName: 'Satz',
      attributName: 'satz',
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 9,
      columnName: 'in',
      attributName: 'satzWaehrung',
      valueType: 'string',
    },
    {
      id: 10,
      columnName: 'Betrag',
      attributName: 'betrag',
      valueType: 'float',
      fixedDecimalScale: true,
    },
    {
      id: 11,
      columnName: 'in',
      attributName: 'betragWaehrung',
      valueType: 'string',
    },
    {
      id: 12,
      columnName: 'Rechenbasis',
      attributName: 'rechenBasis',
      valueType: 'string',
    },
    {
      id: 13,
      columnName: 'Text',
      attributName: 'text',
      valueType: 'string',
    },
  ];
};
